import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { Modal } from "antd";
import { getAllFeedback } from "@/src/app/service";
import moment from "moment";
const columns = [
  { title: "ID", dataIndex: "id", key: "id", width: 30 },
  { title: "Tên tổ chức", dataIndex: "name", key: "name", width: 100 },
  { title: "Số quyết định", dataIndex: "phone", key: "phone", width: 100 },
  { title: "Nội dung", dataIndex: "content", key: "content", width: 200 },
  {
    title: "Ngày gửi",
    dataIndex: "created_at",
    key: "created_at",
    width: 100,
    render: (date) => moment(date).format("DD/MM/YYYY"),
  },
];
const ViewFeedback = ({ openViewFeedback, setOpenViewFeedback }) => {
  const [data, setData] = useState([]);
  const [totalData, setTotalData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const fetchData = async (pagination) => {
    setIsLoading(true);
    const result = await getAllFeedback({
      page: pagination?.current,
      limit: pagination?.pageSize,
    });
    setData(result?.data);
    setTotalData(result?.total);
    setIsLoading(false);
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <Modal
      open={openViewFeedback}
      onCancel={() => {
        setOpenViewFeedback(false);
      }}
      footer={null}
      closable={true}
      width={1000}
      destroyOnClose={true}
      centered
    >
      <Table
        scroll={{ x: "scroll" }}
        columns={columns}
        dataSource={data}
        loading={isLoading}
        locale={{ emptyText: "Đang cập nhật dữ liệu" }}
        pagination={{
          defaultPageSize: 5,
          total: totalData,
        }}
        onChange={async (pagination, filters, sorter) => {
          await fetchData(pagination);
        }}
      />
    </Modal>
  );
};
export default ViewFeedback;
